import { Industry } from './industry.model';

export class IndustryMapper {
  public static map(industryData: any): Industry {
    if (!industryData) {
      return null;
    }

    return new Industry(
        industryData.id,
        industryData.name
      );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/user/work-record/industry.mapper.ts